export default {

  handleFormValidation() {
    const oForm = $('#form-doc-base');

    const aRules = {
      nombre: {
        required: true
      },
    };

    const aMessages = {
      name: {
        required: 'El campo Nombre es obligatorio.'
      },
    };

    // Validación del formulario
    FormHelper.validate(oForm, aRules, aMessages);
  },

  init() {
    this.handleFormValidation();
  },

  initIndex() {
    FormHelper.handleSearch();
  },
};
